<script lang="ts" setup>
import { injectMultiStepFormContext } from './model';

export type KaMultiStepFormStepProps = {
  // This prop is used for virtualDOM traversal in MultiStepForm.vue
  id: string;
};

const props = defineProps<KaMultiStepFormStepProps>();

const { currentStep } = injectMultiStepFormContext();
</script>
<template>
  <div v-if="currentStep.id === props.id">
    <slot />
  </div>
</template>
